import React, { useState } from "react";
import SideMenu from "../../components/SideMenu";
import { useQuery, useMutation, gql } from "@apollo/client";
import SimpleTextInput from "../../components/forms/SimpleTextInput";
import TitleHeading from "../../components/TitleHeading";
import SimpleSelect from "../../components/forms/SimpleSelect";
import SearchBar from "../../components/search/SearchBar";
import { useAuth0 } from "../../react-auth0-spa";

const GET_PRODUCTS = gql`
  query GetProduct {
    inventory_product {
      id
      width_mm
      length_mm
      height_mm
      case_qty
      base_product {
        id
        base_product_name
        base_product_description
        image_url
      }
    }
  }
`;

const ADD_SUPPLIER_PRODUCT = gql`
  mutation AddSupplierProduct(
    $product_id: Int!
    $supplier_account_id: Int!
    $supplier_product_name: String!
    $supplier_product_reference: String!
    $user_id: String!
  ) {
    insert_inventory_supplier_product_one(
      object: {
        user_id: $user_id
        product_id: $product_id
        supplier_account_id: $supplier_account_id
        supplier_product_name: $supplier_product_name
        supplier_product_reference: $supplier_product_reference
      }
    ) {
      id
    }
  }
`;

const GET_SUPPLIERS = gql`
  query GetSuppliers {
    inventory_account(where: { account_roles: { role: { id: { _eq: 2 } } } }) {
      id
      name: local_name
      account_description
      account_status {
        account_status_name
      }
      account_roles {
        role {
          role_name
        }
      }
    }
  }
`;

const AddSupplierProduct = () => {
  const [inputs, setInputs] = useState({});
  const [successCode, setSuccessCode] = useState(0);
  const {
    loading: loadingProducts,
    error: errorProducts,
    data: dataProducts,
    refetch: refreshProducts,
  } = useQuery(GET_PRODUCTS, {
    fetchPolicy: "network-only",
  });
  const [addSupplierProduct, { loading: mutationLoading, error: mutationError }] = useMutation(
    ADD_SUPPLIER_PRODUCT,
    {
      onCompleted(data) {
        setSuccessCode(200);
        // window.location = "/client-orders/" + data.insert_inventory_base_product_one.id + "/add-order-items"
      },
    }
  );

  const {
    loading: supplierLoading,
    error: supplierError,
    data: supplierData,
    refetch: refreshSuppliers,
  } = useQuery(GET_SUPPLIERS, {
    fetchPolicy: "network-only",
  });

  const handleInputChange = event => {
    event.persist();
    console.log(inputs);

    setInputs(inputs => ({
      ...inputs,
      [event.target.name]: event.target.value,
    }));
  };

  const resetForm = event => {
    if (event) {
      event.preventDefault();
    }
    setInputs({
      name: "",
    });
    setSuccessCode(0);
  };

  const transformProducts = products => {
    console.log(products);
    return products
      ? products.map(p => {
          return {
            id: p.id,
            name: p.base_product.base_product_name + " (" + p.case_qty + ")",
          };
        })
      : [];
  };

  const handleSubmit = event => {
    if (event) {
      event.preventDefault();
    }
    addSupplierProduct({
      variables: {
        supplier_account_id: inputs.supplier_account_id,
        product_id: inputs.product_id,
        supplier_product_name: inputs.supplier_product_name,
        supplier_product_reference: inputs.supplier_product_reference,
        user_id: user_id,
      },
    });
  };

  const { user } = useAuth0();
  const user_id = user ? user.sub : null;

  if (dataProducts == null || loadingProducts) return null;
  if (supplierData == null || supplierLoading) return null;

  return (
    <>
      <div className="bg-gray-100 bg-opacity-25">
        <div className="hidden xl:block">
          <SideMenu
            menuOpen={true}
            layout={"large"}
            selectedMainMenu="SKUs"
            selectedSubMenu="suppliers-product"
          />
        </div>
        <div className="block xl:hidden">
          <SideMenu
            menuOpen={false}
            layout={"mobile"}
            selectedMainMenu="SKUs"
            selectedSubMenu="suppliers-product"
          />
        </div>
      </div>
      <div className="flex flex-row">
        <div className="xl:w-3/12 hidden xl:block">&nbsp;</div>
        <div className="xl:w-9/12 w-full">
          <div className="container max-w-screen-xl lg:pr-8 mt-20 xl:mt-0 leading-normal tracking-normal overflow-x-hidden overflow-y-hidden">
            <SearchBar />
            <div className="flex pt-4 mb-4">
              <div className="w-full h-auto  ml-2">
                <div className="fixed xl:relative xl:top-auto top-0 pt-8 pb-4 xl:pl-0 w-full bg-white xl:bg-transparent z-50 xl:left-auto left-0 xl:ml-0 pl-16 border-b xl:border-none">
                  <TitleHeading label="SKU &gt; Add a new Supplier Product" />
                  {successCode === 200 && (
                    <div
                      className="p-2 bg-green-800 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
                      role="alert"
                    >
                      <span className="flex rounded-full bg-green-500 uppercase px-2 py-1 text-xs font-bold mr-3">
                        Success
                      </span>
                      <span className="font-semibold mr-2 text-left flex-auto">
                        The Supplier Product was added successfully.
                      </span>
                    </div>
                  )}
                  {successCode === 400 && (
                    <div
                      className="p-2 bg-red-800 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
                      role="alert"
                    >
                      <span className="flex rounded-full bg-red-500 uppercase px-2 py-1 text-xs font-bold mr-3">
                        Error
                      </span>
                      <span className="font-semibold mr-2 text-left flex-auto">
                        There was a problem with the data - please check.
                      </span>
                    </div>
                  )}
                </div>

                <form className="w-full flex flex-col lg:flex-row" onSubmit={handleSubmit}>
                  <div className="w-full lg:w-1/2 p-4 lg:p-0">
                    <div className="flex flex-wrap mb-2">
                      <SimpleSelect
                        placeholder="Select the Supplier"
                        refresh_handler={refreshSuppliers}
                        change_handler={handleInputChange}
                        label="Supplier"
                        add_url="/suppliers/add"
                        options={supplierData.inventory_account}
                        id_ref="supplier_account_id"
                        name_func={option => {
                          return option.name;
                        }}
                      />
                    </div>
                    <div className="flex flex-wrap mb-2">
                      <div className="w-full px-3 mb-2 md:mb-0">
                        <div className="flex flex-wrap mb-2">
                          <SimpleSelect
                            placeholder="Select the Product"
                            change_handler={handleInputChange}
                            label="Product"
                            add_url="/products/add"
                            refresh_handler={refreshProducts}
                            options={transformProducts(dataProducts.inventory_product)}
                            id_ref="product_id"
                            name_func={option => {
                              return option.name;
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-wrap mb-2">
                      <SimpleTextInput
                        placeholder="Enter Supplier Product Name"
                        value_ref={inputs.supplier_product_name}
                        required={true}
                        change_handler={handleInputChange}
                        label="supplier product name"
                        id_ref="supplier_product_name"
                      />
                    </div>
                    <div className="flex flex-wrap mb-2">
                      <SimpleTextInput
                        placeholder="Enter Supplier Product Reference"
                        value_ref={inputs.supplier_product_reference}
                        required={true}
                        change_handler={handleInputChange}
                        label="supplier product reference"
                        id_ref="supplier_product_reference"
                      />
                    </div>

                    {successCode !== 200 && (
                      <button
                        className="flex-shrink-0 bg-teal-500 hover:bg-teal-700 border-teal-500 hover:border-teal-700 text-sm border-4 text-white py-1 px-2 rounded"
                        type="submit"
                      >
                        Add
                      </button>
                    )}
                  </div>
                  <div className="w-full lg:w-1/2 p-4 lg:p-0">
                    <div>{inputs.image_url && <img src={inputs.image_url} alt="preview" />}</div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSupplierProduct;
